import React, { Component } from 'react'

import DecoupledLinesChart from 'modules/Charts/DecoupledLines/DecoupledLinesChart'
import ContentChartTitle from 'modules/Content/ContentChart/ContentChartTitle'
import ContentChartFooter from 'modules/Content/ContentChart/ContentChartFooter'
import ContentDateModal from 'modules/Content/ContentChart/ContentDateModal'

import API from 'utils/api/api'
import API_V1_URL from 'utils/api/urls_v1'
import IndicatorTools from 'utils/indicators/indicatorTools'
import DateTools from 'utils/dates/dateTools'

import Loading from 'components/Loading'
import Error from 'components/Error'


const DEFAULT_NUMBER_OF_YEARS_TO_SHOW = 10; //10;


class DecoupledLinesChartContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showLegend: true,
      showByGender: false,
      showTable: false,
      showModal: false,
      expanded: false,
      startingYear: 1900,
      endingYear: 2020,
      minYear: 0,
      maxYear: 0,
      chartRef: null,
      indicatorData: {},
      loading: true,
      error: false
    }
  }

  componentDidMount() {
    let selectedRegionId = this.props.selectedRegionId
    let indicator = this.props.indicator

    // TODO: get from URL?
		let regionsToPlot = [
			selectedRegionId,
      411,
      325,
      2692,
      326,
      560
    ];

    // let query = QueryTools.formatQuerySingleGEOFromId(selectedRegionId)

    // API.getQuery(APIURL.getEvolutionForIndicatorAndRegions({ indicator, query }))
    API.getQuery(API_V1_URL.getIndicatorData( { indicator: indicator, geo: regionsToPlot } ))
      .then( responseData => {
        responseData.data = responseData.data.filter( item => item.value !== null );
        responseData.data.forEach( (item) => {
          item[ "time_year" ] = DateTools.getYearFromDateString( item.time );
        } );

        this.setState( { data: responseData.data } );
        let selectedRegionData = responseData["data"].filter( (item) => item.geo === selectedRegionId );
        return IndicatorTools.getIndicatorEvolutionData( selectedRegionData );
      })
      .then( regionEvolutionData => {
        return IndicatorTools.getMaxAndMinYearFromIndicator( regionEvolutionData );
      } )
      .then((extent) => {
        // console.log(extent);
        let minYear = extent.min;
        let maxYear = extent.max;
        let numberOfYears = this.props.numberOfYears || DEFAULT_NUMBER_OF_YEARS_TO_SHOW;
        if (extent.max - (numberOfYears-1) >= extent.min) {
          minYear = extent.max - (numberOfYears-1);
        }
        // use configProps
        // adjust values for only one tip of period
        let startingYear = null;
        let endingYear = null;
        if (this.props.endingYear && this.props.endingYear <= extent.max) {
          endingYear = this.props.endingYear;
        } else {
          endingYear = extent.max;
        }
        if (this.props.startingYear && this.props.startingYear >= extent.min) {
          startingYear = this.props.startingYear;
        } else {
          startingYear = endingYear - (numberOfYears-1);
        }
        
        if (this.props.startingYear && !this.props.endingYear) {
          endingYear = startingYear + (numberOfYears-1);
        }
        if (!this.props.startingYear && this.props.endingYear) {
          startingYear = endingYear - (numberOfYears-1);
        }

        this.setState({ 
          // evolutionData: indicatorEvolutionData,
          minYear: minYear, 
          maxYear: maxYear, 
          startingYear: startingYear, 
          endingYear: endingYear, 
          loading: false, 
          error: false 
        })
      })
      .catch(reason => {
        console.error( "error", reason );
        this.setState({ loading: false, error: true })
      })

    let indicatorData = this.props.indicatorsData.filter(item => item.id === this.props.indicator)[0]
    this.setState({
      indicatorData
    })
  }

  functionSet() {
    const chartRef = this.state.chartRef
    let shouldShowLegend = this.state.showLegend
    const showLegend = () => {
      shouldShowLegend = !shouldShowLegend
      chartRef.current.chart.legend.update({
        enabled: shouldShowLegend
      })
      this.setState({ showLegend: shouldShowLegend })
    }

    let shouldShowByGender = this.state.showByGender
    const showByGender = () => {
      shouldShowByGender = !shouldShowByGender
      this.setState({ showByGender: shouldShowByGender })
    }
    const showTable = shouldShow => {
      this.setState({ showTable: shouldShow })
    }

    const modalFunctions = () => {
      const setDateRange = ({ startingYear, endingYear }) => {
        this.setState({
          startingYear,
          endingYear
        })
      }
      const openModal = () => {
        this.setState({
          showModal: true
        })
      }
      const closeModal = () => {
        this.setState({
          showModal: false
        })
      }

      return {
        setDateRange,
        openModal,
        closeModal
      }
    }

    const exportChart = fileType => {
      const chart = chartRef.current.getChart()
      let fileName = this.state.indicatorData.name
      let optionsToExport = {
        filename: fileName
      }

      if (fileType === 'CSV') {
        const csv = chart.getCSV(false)
        const hiddenElement = document.createElement('a')
        hiddenElement.href = 'data:attachment/text,' + encodeURI(csv)
        hiddenElement.target = '_blank'
        hiddenElement.download = fileName + '.csv'
        hiddenElement.click()
      } else {
        switch (fileType) {
        case 'PNG':
          optionsToExport.type = 'image/png'
          break
        case 'JPEG':
          optionsToExport.type = 'image/jpeg'
          break
        case 'PDF':
          optionsToExport.type = 'application/pdf'
          break
        case 'SVG':
          optionsToExport.type = 'image/svg+xml'
          break
        default:
          optionsToExport.type = 'image/png'
          break
        }
        chart.exportChart(optionsToExport)
      }
    }
    const expandChart = () => {
      const shouldExpand = !this.state.expanded

      if (shouldExpand) {
        document.getElementsByTagName('html')[0].classList.add('ork-no-scroll')
      } else {
        document.getElementsByTagName('html')[0].classList.remove('ork-no-scroll')
      }
      this.setState({ expanded: shouldExpand })
    }

    return {
      showLegend,
      showByGender,
      showTable,
      modalFunctions,
      exportChart,
      expandChart
    }
  }

	getRef = ref => {
	  this.setState({ chartRef: ref })
	}

	renderIfAllOK() {
	  let renderingComponent = null
	  if (this.state.error) {
	    renderingComponent = <Error />
	  } else if (this.state.loading) {
	    renderingComponent = <Loading />
	  } else {
	    let { regionsData, countriesData, referenceRegionsData, sameCountryRegionsData, allRegionsGroupRegionId } = this.props
	    let comparative
	    if (this.props.otherRegionsFilter !== undefined && this.props.otherRegionsFilter.length !== 0) {
	      comparative = this.props.otherRegionsFilter
	    } else {
	      comparative = {}
	    }
	    let generalRegionsData = {
	      regionsData,
        countriesData,
	      referenceRegionsData,
        sameCountryRegionsData,
        comparative,
        allRegionsGroupRegionId
	    }
	    let linesToShow = {
	      allRegionsFilter: this.props.allRegionsFilter,
	      referenceRegionsFilter: this.props.referenceRegionsFilter,
	      sameCountryRegionsFilter: this.props.sameCountryRegionsFilter,
	      otherRegionsFilter: comparative
	    }

      let allowFullscreen = true;
      if ( this.props.embed ) {
        allowFullscreen = false;
      }

	    renderingComponent = (
	      <React.Fragment>
	        <div className={`panel panel-default ${this.state.expanded ? 'panel-expanded' : ''}`}>
	          <ContentChartTitle indicator={this.props.indicator} layer={this.props.layer} chartType={'evolutionAbsolute'} />
	          <div className="panel-body">
	            <DecoupledLinesChart
	              generalRegionsData={JSON.stringify(generalRegionsData)}
	              linesToShow={JSON.stringify(linesToShow)}
	              indicator={this.props.indicator}
                data={this.state.data}
	              startingYear={this.state.startingYear}
	              endingYear={this.state.endingYear}
	              selectedRegionId={this.props.selectedRegionId}
                geoIds={this.props.geoIds}
                regionsToPlot={this.props.regionsToPlot}
	              indicatorData={this.state.indicatorData}
	              expanded={this.state.expanded}
	              showLegend={this.state.showLegend}
	              showByGender={this.state.showByGender}
	              fn={this.getRef}
	            />
	          </div>
	          <ContentChartFooter
	            fn={this.functionSet()}
              showLinkToDetail={false}
              allowFullscreen={allowFullscreen}
	            indicatorData={this.state.indicatorData}
	            expanded={this.state.expanded}
	            chartType={'evolutionAbsolute'}
	            showByGender={this.state.showByGender}
	          />
	        </div>
	        <ContentDateModal
	          show={this.state.showModal}
	          fn={this.functionSet().modalFunctions()}
	          startingYear={this.state.startingYear}
	          endingYear={this.state.endingYear}
	          minYear={this.state.minYear}
	          maxYear={this.state.maxYear}
	          multiple={true}
	        />
	      </React.Fragment>
	    )
	  }
	  return renderingComponent
	}

	render() {
	  return <div>{this.renderIfAllOK()}</div>
	}
}

DecoupledLinesChartContainer.defaultProps = {
  startingYear: null,
  endingYear: null,
  numberOfYears: DEFAULT_NUMBER_OF_YEARS_TO_SHOW,
  regionsToPlot: null
};

export default DecoupledLinesChartContainer;



// WEBPACK FOOTER //
// ./src/modules/Charts/DecoupledLines/DecoupledLinesChartContainer/DecoupledLinesChartContainer.jsx